import domain from "./DomainService";

/**
 * Returns x raised to the n-th power.
 *
 * @param {{newemail: String}} formValues user's email
 * @return {Promise}
 */
export default function ChangeEmailService(formValues) {
  const token = localStorage.getItem("token");
  const options = {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: "JWT " + token,
    },
    body: JSON.stringify({
      new_email: formValues.newemail,
    }),
  };
  return fetch(domain() + "change-email", options);
}
